import { extendSession } from '@kitopi-com/auth';
import type { InternalAxiosRequestConfig } from 'axios';

export const addAuthorizationHeader = async (
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  const session = await extendSession();

  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: session.idToken.jwtToken,
    },
  } as InternalAxiosRequestConfig;
};
